export const GITCARD_DISPLAYAREAS_LOADING = 'REDUX_SAGA_GITCARD_DISPLAYAREAS_LOADING';
export const GET_GITCARD_DISPLAYAREAS_DATA_SUCCESS = 'REDUX_SAGA_GET_GITCARD_DISPLAYAREAS_DATA_SUCCESS';
export const RESET_GITCARD_DISPLAYAREAS = "REDUX_SAGA_RESET_GITCARD_DISPLAYAREAS";
export const GET_GITCARD_DISPLAYAREAS_DATA_ERROR = 'REDUX_SAGA_GET_GITCARD_DISPLAYAREAS_DATA_ERROR';

export const actionGetGiftCardDisplayAreas = (dispatch) => {
    dispatch({ type: GITCARD_DISPLAYAREAS_LOADING })
};

export const actionResetGiftCardDisplayAreas = (dispatch) => {
    dispatch({ type: RESET_GITCARD_DISPLAYAREAS })
};